import React, { useState } from 'react';
import { useUser, UserData } from '../contexts/UserContext';
import { ShieldAlertIcon, XIcon, PlusIcon, SearchIcon, UserIcon } from 'lucide-react';
// Mock users for the search modal
const MOCK_USERS: UserData[] = [{
  name: 'Alice Smith',
  email: 'alice@dealer.com',
  role: 'dealer',
  companyName: 'AgriTech',
  companyLogo: null,
  officialCountry: 'USA'
}, {
  name: 'Bob Jones',
  email: 'bob@customer.com',
  role: 'customer',
  companyName: 'FarmCorp',
  companyLogo: null,
  officialCountry: 'Canada'
}, {
  name: 'Carlos Ruiz',
  email: 'carlos@aisco.com',
  role: 'sales-manager',
  companyName: 'Aisco',
  companyLogo: null,
  officialCountry: 'Spain'
}, {
  name: 'Diana Prince',
  email: 'diana@aisco.com',
  role: 'region-admin',
  companyName: 'Aisco',
  companyLogo: null,
  officialCountry: 'UK'
}];
export function ImpersonationBar() {
  const {
    isImpersonating,
    impersonatedUsers,
    originalUser,
    email: currentEmail,
    impersonateUser,
    removeImpersonatedUser,
    returnToOriginal,
    stopImpersonation
  } = useUser();
  const isOwnerActive = originalUser ? currentEmail === originalUser.email : false;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  if (!isImpersonating) return null;
  const filteredUsers = MOCK_USERS.filter(u => u.name.toLowerCase().includes(searchQuery.toLowerCase()) || u.email.toLowerCase().includes(searchQuery.toLowerCase()));
  return <>
      <div className="bg-amber-600/90 text-white px-4 py-2 flex items-center justify-between z-[100] relative shadow-md" data-id="element-3435" data-mp="17ayj2sb2lev7">
        <div className="flex items-center gap-4 overflow-x-auto no-scrollbar" data-id="element-3436" data-mp="12jow5zgwopn0">
          <div className="flex items-center gap-2 flex-shrink-0 font-medium" data-id="element-3437" data-mp="yjoiih1msih0">
            <ShieldAlertIcon size={16} data-id="element-3438" data-mp="1v118t1rii8qn" />
            <span data-id="element-3439" data-mp="1v22t7wuf47l1">Impersonation Active</span>
          </div>

          <div className="h-4 w-px bg-white/30 flex-shrink-0" data-id="element-3440" data-mp="1qakuzgjs4l3r" />

          <div className="flex items-center gap-2" data-id="element-3441" data-mp="1q91eppy4ia1z">
            {/* Owner badge — original admin who started the impersonation */}
            {originalUser && <button onClick={returnToOriginal} className={`flex items-center gap-2 px-3 py-1 rounded-full text-xs font-medium transition-all whitespace-nowrap border-2 ${isOwnerActive ? 'bg-white text-amber-700 border-white shadow-md' : 'bg-transparent border-dashed border-white/60 hover:bg-white/10 text-white'}`} title={`Return to ${originalUser.name} (your account)`} data-id="element-3442" data-mp="3phsvsrx1o7vt">
                <UserIcon size={12} data-id="element-3443" data-mp="36qrys9fhimew" />
                <span className="font-semibold" data-id="element-3444" data-mp="36rtb0h88ley7">{originalUser.name}</span>
              </button>}

            {originalUser && impersonatedUsers.length > 0 && <div className="h-4 w-px bg-white/30 flex-shrink-0" data-id="element-3445" data-mp="2rvlpndl3e7hc" />}

            {impersonatedUsers.map(user => {
            const isActive = currentEmail === user.email;
            return <div key={user.email} className={`group flex items-center gap-2 pl-3 pr-1 py-1 rounded-full text-xs font-medium transition-colors whitespace-nowrap border ${isActive ? 'bg-white text-amber-700 border-white shadow-sm' : 'bg-black/10 border-white/20 hover:bg-black/20 text-white'}`} data-id="element-3446" data-mp="q2nu39zxl0sp">
                  <button onClick={() => impersonateUser(user)} className="flex items-center gap-2" data-id="element-3447" data-mp="2alroogvby4iv">
                    <UserIcon size={12} data-id="element-3448" data-mp="2pae1aatkoi6e" />
                    <span data-id="element-3449" data-mp="2kiml8u81luui">{user.name}</span>
                    <span className={`px-1.5 py-0.5 rounded text-[10px] uppercase ${isActive ? 'bg-amber-100 text-amber-800' : 'bg-black/20 text-white/90'}`} data-id="element-3450" data-mp="2khkznvtehpyj">
                      {user.role.replace('-', ' ')}
                    </span>
                  </button>
                  <button onClick={e => {
                e.stopPropagation();
                removeImpersonatedUser(user.email);
              }} className={`ml-0.5 w-5 h-5 flex items-center justify-center rounded-full transition-colors ${isActive ? 'hover:bg-amber-200 text-amber-700' : 'hover:bg-white/20 text-white/70 hover:text-white'}`} title={`Remove ${user.name}`} data-id="element-3451" data-mp="388gwx8gmldd6">
                    <XIcon size={11} data-id="element-3452" data-mp="1ac0czotxc8hg" />
                  </button>
                </div>;
          })}

            <button onClick={() => setIsModalOpen(true)} className="flex items-center justify-center w-7 h-7 rounded-full bg-black/10 hover:bg-black/20 border border-white/20 transition-colors flex-shrink-0" title="Impersonate another user" data-id="element-3453" data-mp="1aecuy1zomiui">
              <PlusIcon size={14} data-id="element-3454" data-mp="1p87uuihv0xtk" />
            </button>
          </div>
        </div>

        <button onClick={stopImpersonation} className="flex items-center gap-1.5 px-3 py-1.5 bg-black/20 hover:bg-black/30 rounded-lg text-sm font-medium transition-colors flex-shrink-0 ml-4" data-id="element-3455" data-mp="rm0ph6dqf1g5">
          <XIcon size={14} data-id="element-3456" data-mp="11j532htiholc" />
          Exit
        </button>
      </div>

      {isModalOpen && <div className="fixed inset-0 z-[200] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4" data-id="element-3457" data-mp="16a51xsm6ygqh">
          <div className="bg-[#0f1d3a] rounded-xl shadow-2xl border border-white/10 w-full max-w-lg overflow-hidden flex flex-col max-h-[80vh]" data-id="element-3458" data-mp="8vizh9kaajyh">
            <div className="px-6 py-4 border-b border-white/10 flex items-center justify-between" data-id="element-3459" data-mp="ds9jg7z7lzp6">
              <h2 className="text-white font-semibold text-lg" data-id="element-3460" data-mp="2r3km081r4bij">
                Impersonate User
              </h2>
              <button onClick={() => setIsModalOpen(false)} className="text-blue-300 hover:text-white p-1 rounded-lg hover:bg-white/10 transition-colors" data-id="element-3461" data-mp="2n0xt03tcgkjr">
                <XIcon size={20} data-id="element-3462" data-mp="2d3t25qok00wm" />
              </button>
            </div>

            <div className="p-4 border-b border-white/10" data-id="element-3463" data-mp="2861dr6n4awx6">
              <div className="relative" data-id="element-3464" data-mp="287m3miyhlrop">
                <SearchIcon size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-blue-300/50" data-id="element-3465" data-mp="23eja2atpmi8i" />
                <input type="text" placeholder="Search users by name or email..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full bg-white/5 border border-white/10 rounded-lg pl-9 pr-4 py-2 text-sm text-white placeholder-blue-300/50 focus:outline-none focus:ring-2 focus:ring-blue-500" autoFocus data-id="element-3466" data-mp="1ze96f4te43wt" />
              </div>
            </div>

            <div className="flex-1 overflow-y-auto p-2 no-scrollbar" data-id="element-3467" data-mp="1askuraf5zcyo">
              {filteredUsers.length === 0 ? <div className="p-8 text-center text-blue-300/70 text-sm" data-id="element-3468" data-mp="1fr4mxskcpkzh">
                  No users found matching "{searchQuery}"
                </div> : <div className="space-y-1" data-id="element-3469" data-mp="11sy2pf8brjia">
                  {filteredUsers.map(user => <button key={user.email} onClick={() => {
              impersonateUser(user);
              setIsModalOpen(false);
            }} className="w-full flex items-center justify-between p-3 rounded-lg hover:bg-white/5 transition-colors text-left group" data-id="element-3470" data-mp="15sgf1mm2ym9i">
                      <div className="flex items-center gap-3" data-id="element-3471" data-mp="1kqh4pywd81v7">
                        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center flex-shrink-0" data-id="element-3472" data-mp="1kq8ru708swk0">
                          <span className="text-sm font-bold text-white" data-id="element-3473" data-mp="2chewn0qwrifm">
                            {user.name.split(' ').map(n => n[0]).join('').substring(0, 2)}
                          </span>
                        </div>
                        <div data-id="element-3474" data-mp="5s3ev8h2jk45">
                          <p className="text-white font-medium text-sm group-hover:text-blue-200 transition-colors" data-id="element-3475" data-mp="5r1tob6c9h8p">
                            {user.name}
                          </p>
                          <p className="text-blue-300/70 text-xs" data-id="element-3476" data-mp="fig2xao3dvf1">
                            {user.email}
                          </p>
                        </div>
                      </div>
                      <div className="flex flex-col items-end" data-id="element-3477" data-mp="3j06ikvl4rhjs">
                        <span className="px-2 py-1 rounded bg-white/10 text-blue-200 text-[10px] uppercase font-semibold tracking-wider" data-id="element-3478" data-mp="3e1wo6n78ckz8">
                          {user.role.replace('-', ' ')}
                        </span>
                        <span className="text-blue-300/50 text-xs mt-1" data-id="element-3479" data-mp="3nxg80b8irt7m">
                          {user.companyName}
                        </span>
                      </div>
                    </button>)}
                </div>}
            </div>
          </div>
        </div>}
    </>;
}